module.exports = "<app-header></app-header>\n\n<div class=\"content-container container\">\n  <router-outlet></router-outlet>\n</div>\n\n<footer class=\"footer\" *ngIf=\"currentRoute !== 'orguserActivate'\">\n  <div class=\"container\">\n    <p class=\"text-muted pull-right\">IMS GUI BBC © 2017</p>\n  </div>\n</footer>\n<app-error-handler></app-error-handler>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main